import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  if (!prompt || dismissed || isStandalone) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex items-center gap-2 bg-[#004030] text-white rounded-full pl-4 pr-2 py-2 shadow-2xl animate-floaty" data-testid="install-pwa">
      <Download size={18} className="text-[#e0c05a]" />
      <button onClick={install} className="text-sm font-semibold" data-testid="install-pwa-btn">Install app</button>
      <button onClick={() => setDismissed(true)} className="text-white/60 hover:text-white p-1" aria-label="Dismiss"><X size={15} /></button>
    </div>
  );
}
